import en, { TranslationMessages } from './en';
import flattenMessages from '@liveauctioneers/caterwaul-components/lib/utils/flattenMessages';

/* eslint-disable sort-keys/sort-keys-fix, max-len */
const no: TranslationMessages = {
    bidding_console: {
        console: {
            button: {
                backToLiveItem: 'Tilbake til Live-lott',
                addPaymentMethod: 'Legg til Betaling for å gi Bud',
                login: 'Logg Inn for å By',
                signup: 'Registrer deg for å By',
                register_long: 'Registrer deg for Auksjon',
                pending: 'Avventer Registreringsbekreftelse',
                declined: 'Registrering Avvist',
                suspended: 'Konto Suspendert',
                closed: 'Lott Stengtg',
                sent: 'Du sendte et bud på {amount}',
                outbid: 'Utbydd! By {amount}',
                bid: 'By {amount}',
                winning: 'Du Vinner',
                waiting: 'Venter du fortsatt på registreringsbekreftelse?',
                limit_exceeded: 'Dette objectet vil overskride budgrensen din på {limit}',
                approved_limited: 'Du er godkjent til å by opp til {limit} og har {balance} igjen.',
                show_settings: 'Vis Innstillinger',
                hide_settings: 'Skjul Innstillinger',
                bidding_locked: 'Budgivning låst',
                bidding_unlocked: 'Budgivning åpnet',
            },
            conversions: {
                lot_number: 'Lott {lotNumber}',
            },
            currentLiveItem: {
                auctioneerInfo: {
                    buttons: {
                        askAQuestion: 'Still Spørsmål Her',
                        follow: 'Følg',
                        following: 'Følger',
                        followingAuctioneer: 'Følger Auksjonshus',
                        followAuctioneer: 'Følg Auksjonshus',
                    },
                },
                buyersPremium: {
                    middleLowCutOff: '{middle}% over',
                    middleCutOff: '{middle}% opp til',
                    highCutOff: '{high}% over',
                    lowCutOff: '{low}% opp til',
                    lowPercentage: '{low}%',
                },
                curator: {
                    curatedBy: 'Auksjon Kurarert Av',
                },
                headers: {
                    buyersPremium: 'Kjøpers Premium',
                    condition: 'Tilstand',
                    description: 'Beskrivelse',
                    dimensions: 'Dimensjoner',
                    itemDetails: 'Detaljer',
                    weight: 'Vekt',
                },
            },
            description: {
                estimate_range: 'Est. {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
                single_estimate: 'Est. {number}',
                currentBid: 'Current Bid: {amount}',
                convertedBid: 'Conversion: {amount}',
            },
            lotTracker: {
                bid: 'By',
                bids: 'Bud',
                liveNow: 'Nå Live',
                soldFor: 'Solgt For',
                passed: 'Passert',
            },
            messages: {
                ask_price_changed_to: 'Ask Price Changed: {amount}{converted}',
                bid_limit_exceeded: 'Budgrensen din er overskredet',
                competing_bid_amount: '{amount}{converted}: Konkurrerende Bud',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    'Konkurrerende budgiver ble utbydd av budgiver {paddleNumber} sitt fraværende bud',
                last_bid_retracted: 'Forrige bud på{amount}{converted} er trukket tilbake',
                limited_approval: 'Godkjent for å by opp til {limit}',
                liveauctioneers_bid_amount: '{amount}{converted}: LiveAuctioneers-budgiver {paddleNumber}',
                liveauctioneers_bid_amount_absentee:
                    '{amount}{converted}: LiveAuctioneers-budgivers {paddleNumber} sitt fraværende bud',
                lot_number_passed: 'Lott {lotNumber} Passert',
                lot_number_reopened: 'Lott {lotNumber} Gjenåpnet',
                lot_number_skipped: 'Lott {lotNumber} ble hoppet over',
                lot_number_unsold: 'Lot {lotNumber} Usolgt',
                lot_opened_asking: 'Lot {lotNumber} Åpnet - Pris {amount}{converted}',
                lot_sold_competing_bidder: 'Lot {lotNumber} sold for {amount}{converted} to Competing Bidder',
                lot_sold_liveauctioneers_bidder:
                    'Lott {lotNumber} solgt for {amount}{converted} ti Budgiver {paddleNumber}',
                my_bid_amount: '{amount}{converted}: Mitt Bud',
                my_bid_amount_absentee: '{amount}{converted}: Mitt Fraværsbud',
                my_bid_retracted: 'Ditt Bud på {amount}{converted} ble trukket tilbake',
                paused: 'Auksjonen er satt på pause',
                registration_approved: 'Registreringen din er godkjent',
                reserve_not_met: 'Reserve ikke oppfylt',
                you_been_outbid_by_liveauctioneers_absentee:
                    'Du har blitt utbydd av budgiver {paddleNumber} sitt fraværende bud',
                you_ve_won_lot: 'Du Har Vunnet Lott {lotNumber}',
            },
            settingsMenu: {
                headerText: 'Innstillinger',
                language: 'Språk',
                currency: 'Valuta',
            },
            missives: {
                fair_warning_lot_about_to_close: 'Obs!... Denne lotten er i ferd med å stenge',
                going_once_going_twice: 'FØRSTE GANG... ANDRE GANG...',
                third_and_final_warning: 'TREDJE OG SISTE ADVARSEL...',
            },
            status: {
                remaining: '{remaining} av {total} gjenværende lotter',
                nextBid: {
                    text: 'Mitt Neste Bud',
                    value: '{total} Unna',
                },
                nextFavorite: {
                    text: 'Min neste Favoritt',
                    value: '{total} Unna',
                },
            },
            thumbnail_scroller: {
                next: 'Kommende Lotter',
            },
            lockText: {
                locked: 'Lås Opp for å By',
                unlocked: 'Budgivning er Låst Opp',
            },
            mobileHeader: {
                title: '{lotNumber}: {title}',
            },
            mobileFooter: {
                itemSaves: '{savedCount}',
            },
        },
        explainer_modal: {
            title: 'Velkommen til Auksjonen',
            subtext: 'Lykke til! Vennligst ta noen sekunder for å se gjennom auksjonsdetaljene.',
            fee_disclaimer:
                'Prisen på budet ditt inkluderer ikke potensielle gebyrer, for eksempel en kjøpers premie, skatt, frakt eller behandlingsgebyr',
            autopay_disclaimer: 'Du vil bli belastet hele prisen kort tid etter at auksjonen er avsluttet',
            shipping_disclaimer:
                'Fraktdetaljer finner du i denne auksjonens retningslinjer for frakt, betaling og generelle retningslinjer',
            button: 'Jeg forstår',
        },
        wait: {
            title: 'Følg med. Auksjonen starter snart',
            status_message: '{name} er glad for at du er her!',
            login_button_text: 'Logg Inn',
            register_button_text: 'Registrer deg for Auksjonen',
            image_slider_text: 'Populære Lotter i denne Auksjonen',
            hidden_text: 'Se Katalogen',
            card: {
                title: 'Lotl {lotNumber}: {title}',
                bid: 'By',
                bids: 'Bud',
            },
        },
        done: {
            title: '{title} er avsluttet',
            status_message: 'Følg {name} for å høre mer om deres neste auksjon.',
            live_catalogs_title: 'Se andre Live-auksjoner',
            upcoming_catalogs_title: 'Kommende Auksjoner',
        },
    },
};

export default { ...en, ...flattenMessages(no) };
